import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import NumberHelper from 'helpers/number-helper';
import {inRange} from 'helpers/common-helper';
import InputText from 'components/atoms/inputs/input-text';

class FilterInput extends Component {
    constructor(props) {
        super(props);
        this.isValueBeingChanged = false;
        this.state = {
            fieldValue: '',
        };
    }

    onChange(value) {
        this.isValueBeingChanged = true;
        this.setState({fieldValue: value});
    }

    onBlur(inputValue) {
        const {lineupsQuantity} = this.props;

        const value = NumberHelper.prepareInt(inputValue)
            .limitByRange(
                lineupsQuantity.getMinBoundary(),
                lineupsQuantity.getMaxBoundary(),
                lineupsQuantity.getMinBoundary(),
                lineupsQuantity.getMaxBoundary(),
            )
            .get();

        this.onChange(value);
        this.isValueBeingChanged = false;

        this.props.dispatch(Action.set('LineupsQuantity', value));
    }

    getValue() {
        let currentValue = this.state.fieldValue;
        if (!this.isValueBeingChanged || !currentValue) {
            const {lineupsQuantity} = this.props;
            const rangeValue = lineupsQuantity.getLineupsQuantity();
            const min = lineupsQuantity.getMinBoundary();
            const max = lineupsQuantity.getMaxBoundary();
            currentValue = inRange(rangeValue, min, max) ? rangeValue : min;
        }
        return currentValue;
    }

    render() {
        const {testId} = this.props;
        const currentValue = this.getValue();

        return <InputText value={currentValue} onBlur={::this.onBlur} keyboard="number" testId={testId} />;
    }
}

function mapStatesToProps(state) {
    const {lineupsQuantity} = state;
    return {
        lineupsQuantity,
    };
}

export default connect(mapStatesToProps)(FilterInput);
